import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ConsumerApplications from "./pages/ConsumerApplications";
import ShopReimbursements from "./pages/ShopReimbursements";
import ParticipatingShops from "./pages/ParticipatingShops";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import FAQs from "./pages/FAQs";
import ContactUs from "./pages/ContactUs";
import "./App.css";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Open Sans, -apple-system, Roboto, Helvetica, sans-serif",
          colorPrimary: "#4979A7",
        },
        components: {
          Menu: {
            itemSelectedBg: "rgba(73, 121, 167, 0.1)",
            itemSelectedColor: "#4979A7",
            itemHoverBg: "rgba(73, 121, 167, 0.05)",
          },
          Table: {
            headerBg: "#FAFAFA",
            headerColor: "#AAA",
            borderColor: "#E0E0E0",
          },
        },
      }}
    >
      <Router>
        <Routes>
          <Route path="/" element={
            <Layout>
              <Dashboard />
            </Layout>
          } />
          <Route
            path="/consumer-applications"
            element={
              <Layout>
                <ConsumerApplications />
              </Layout>
            }
          />
          <Route
            path="/shop-reimbursements"
            element={
              <Layout>
                <ShopReimbursements />
              </Layout>
            }
          />
          <Route
            path="/participating-shops"
            element={
              <Layout>
                <ParticipatingShops />
              </Layout>
            }
          />
          <Route
            path="/reports"
            element={
              <Layout>
                <Reports />
              </Layout>
            }
          />
          <Route
            path="/users"
            element={
              <Layout>
                <Users />
              </Layout>
            }
          />
          <Route
            path="/faqs"
            element={
              <Layout>
                <FAQs />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactUs />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;
